/**
 * Custom hook for translations
 * Wraps react-i18next's useTranslation with our LanguageContext
 */
import { useTranslation as useI18nTranslation } from 'react-i18next';
import { useLanguage } from '../contexts/LanguageContext';
import { useEffect } from 'react';

export const useTranslation = (namespace = 'translation') => {
  const { t, i18n } = useI18nTranslation(namespace);
  const { currentLanguage, changeLanguage } = useLanguage();

  // Sync i18next language with LanguageContext
  useEffect(() => {
    if (i18n.language !== currentLanguage) {
      i18n.changeLanguage(currentLanguage);
    }
  }, [currentLanguage, i18n]);

  // Override changeLanguage to sync both systems
  const changeLanguageSync = async (langCode) => {
    await i18n.changeLanguage(langCode);
    await changeLanguage(langCode);
  };

  return {
    t,
    i18n,
    currentLanguage,
    changeLanguage: changeLanguageSync,
  };
};

export default useTranslation;

